// Zentrale SEO-/AEO-Konfiguration.
// Die kanonische Host-URL der Produktionsseite. Ohne abschließenden Slash.
export const SITE_URL = "https://www.wilms.eu";

export const SITE_NAME = "Wilms Rechtsanwälte";

// Standard-Vorschaubild für Open Graph / Twitter Cards.
export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`;

// Titel-Suffix, der an Unterseiten-Titel angehängt wird.
export const TITLE_SUFFIX = ` | ${SITE_NAME}`;

// Name, Adresse, Telefon (NAP) – die zentrale Entität der Kanzlei.
// Wird sowohl für JSON-LD als auch für konsistente Meta-Daten genutzt.
export const ORGANIZATION = {
  name: SITE_NAME,
  legalName: "Wilms Rechtsanwälte GbR",
  url: SITE_URL,
  telephone: "+49 30 75 79 64 0",
  faxNumber: "+49 30 75 79 64 8",
  email: "rae@wilms.eu",
  streetAddress: "Alt-Tempelhof 37/41",
  postalCode: "12103",
  addressLocality: "Berlin",
  addressCountry: "DE",
  // Ungefähre Koordinaten Alt-Tempelhof 37/41, 12103 Berlin.
  latitude: 52.4657,
  longitude: 13.3855,
};

// Baut aus einem Pfad (z.B. "/rechtsanwaelte") eine absolute kanonische URL.
export const canonical = (path: string = "/"): string => {
  if (!path || path === "/") return `${SITE_URL}/`;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};

// Site-weites JSON-LD der Kanzlei (LegalService). Wird auf der Startseite
// eingebunden und zusätzlich statisch in public/index.html gespiegelt.
export const legalServiceJsonLd = () => ({
  "@context": "https://schema.org",
  "@type": "LegalService",
  "@id": `${SITE_URL}/#organization`,
  name: ORGANIZATION.name,
  legalName: ORGANIZATION.legalName,
  url: `${SITE_URL}/`,
  telephone: ORGANIZATION.telephone,
  faxNumber: ORGANIZATION.faxNumber,
  email: ORGANIZATION.email,
  image: DEFAULT_OG_IMAGE,
  logo: DEFAULT_OG_IMAGE,
  address: {
    "@type": "PostalAddress",
    streetAddress: ORGANIZATION.streetAddress,
    postalCode: ORGANIZATION.postalCode,
    addressLocality: ORGANIZATION.addressLocality,
    addressCountry: ORGANIZATION.addressCountry,
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: ORGANIZATION.latitude,
    longitude: ORGANIZATION.longitude,
  },
  areaServed: [
    { "@type": "City", name: "Berlin" },
    { "@type": "Country", name: "Deutschland" },
  ],
  knowsAbout: [
    "Verkehrsrecht",
    "Medizinrecht",
    "Arbeitsrecht",
    "Familienrecht",
    "Datenschutzrecht",
    "Miet- und Wohnungseigentumsrecht",
    "Gewerblicher Rechtsschutz und Urheberrecht",
    "Erbrecht",
    "Transportrecht",
    "Handels- und Gesellschaftsrecht",
    "Allgemeines Zivilrecht",
  ],
});
